<template>
  <div class="mt-4 about-page">
    <div class="row">
      <div class="col-4 col-lg-3">
        <about-nav />
      </div>
      <div class="col-7 text-left">
        <h2 class="mb-4">License Options</h2>

        <h4 class="">Free Gradients</h4>
        <p>
          Gradients available on the site are free to use on personal and commercial projects, <strong>with attribution</strong>.
        </p>
        <p> This can be as simple as a comment in the code, but a link back to the site is even better!</p>

        <h4 class="mt-4">Standard License</h4>
        <p>
          All of the <router-link to="/premium">premium bundles</router-link> give you the standard license.
          This lets you:
        </p>
        <ul>
          <li>Use all gradients and derived images in unlimited commercial and personal projects, for yourself, your company, or clients.</li>
          <li>Use all gradients and derived images in applications, software and UI/UX design.</li>
          <li>Use all gradients and derived images without attribution.</li>
        </ul>

        <h4 class="mt-4">Extended License</h4>
        <p>
          For most users the standard license is appropriate. 
          However, you may need the <router-link to="/extended">extended license</router-link> if you want to:
        </p>
        <ul>
          <li>Use gradients in projects that will be distributed (like templates or physical merchandise)</li>
          <li>Let users customize an application or screen by selecting between gradients.</li>
          <li>Share gradients and other downloaded files with any number of coworkers at your organization.</li>
        </ul>
        <p>See <router-link to="/extended">more details</router-link> or <router-link to="/contact">contact me</router-link> with questions.</p>

        <h4 class="mt-4">Re-distributing Gradients</h4>
        <p>None of the licenses give you permission to re-distribute or re-sell gradients or their derived images.</p>
      
      </div>
    </div>
  </div>
</template>

<script>
import AboutNav from "@/components/AboutNav.vue"

export default {
  components: {
    AboutNav
  } 
}
</script>

<style lang="scss">
.about-page {

  li {
    margin-bottom: .5rem;
  }
}
</style>